import { render, staticRenderFns } from "./EvaluacionDeProveedores.vue?vue&type=template&id=5c0af12c&"
import script from "./EvaluacionDeProveedores.vue?vue&type=script&lang=js&"
export * from "./EvaluacionDeProveedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports